module.exports = __webpack_public_path__ + "static/media/arrow_circle_right_white.a06a3cdb.svg";